import React, { useState } from 'react';

const TracingGame = ({ config, onEnd }) => {
    const [step, setStep] = useState(0);
    const points = config.path || [{ x: 20, y: 50 }, { x: 80, y: 50 }];

    const handlePointEnter = (index) => {
        if (index === step) {
            setStep(step + 1);
            if (index === points.length - 1) {
                setTimeout(() => onEnd(100), 500);
            }
        }
    };

    if (step >= points.length) {
        return <div className="tracing-finished"><h2>Parfait ! Mouvement réussi.</h2></div>;
    }

    return (
        <div className="tracing-container">
            <h2 className="tracing-instruction">Reliez les points dans l'ordre</h2>

            <svg className="tracing-svg-layer">
                <polyline
                    points={points.map(p => `${p.x}%,${p.y}%`).join(' ')}
                    className="tracing-path-bg"
                />
                <polyline
                    points={points.slice(0, step + 1).map(p => `${p.x}%,${p.y}%`).join(' ')}
                    className="tracing-path-fill"
                />
            </svg>

            {points.map((p, idx) => (
                <div
                    key={idx}
                    onMouseEnter={() => handlePointEnter(idx)}
                    onClick={() => handlePointEnter(idx)}
                    className={`tracing-point ${idx < step ? 'completed' : (idx === step ? 'active' : 'upcoming')}`}
                    style={{ left: `${p.x}%`, top: `${p.y}%` }}
                >
                    {idx + 1}
                </div>
            ))}
        </div>
    );
};

export default TracingGame;